import React from "react";
import NoImage from "assets/images/image_not_found.webp";

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  src?: string | undefined;
  fallback?: string;
};

const ImageWithFallback: React.FC<Props> = ({
  src,
  fallback = NoImage,
  ...rest
}) => {

const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = fallback;
  };

  return <img {...rest} src={src || fallback} onError={handleError} />;
};

export default ImageWithFallback;
